// Generated by Melange

import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__BlogHero from "./BlogHero.js";
import * as Buhta_landing__BlogPagination from "../../../components/blog/BlogPagination.js";
import * as Buhta_landing__BlogPosts from "./BlogPosts.js";
import * as Buhta_landing__BlogSearch from "./BlogSearch.js";
import * as Buhta_landing__BlogSidebar from "../../../components/blog/sidebar/BlogSidebar.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__LoadingBar from "../../../core/LoadingBar.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BlogHomePage(Props) {
  let pageNum = Props.pageNum;
  let slugOpt = Props.slug;
  let language = Props.language;
  const slug = slugOpt !== undefined ? slugOpt : "";
  const match = Buhta_landing__LoadingBar.LoadingBarContext.useLoadingBar(undefined);
  const dispatchLoadingBar = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setSearchField = match$1[1];
  const match$2 = React.useState(function () {
    return "";
  });
  const setQuery = match$2[1];
  const query = match$2[0];
  const match$3 = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match$3[1];
  const content = match$3[0];
  const tags = content.blogTags;
  let currentTag;
  try {
    currentTag = Stdlib__List.find((function (tag) {
      return tag.title === slug;
    }), tags);
  }
  catch (exn){
    currentTag = {
      tag: "",
      title: "",
      id: ""
    };
  }
  const result = content.blogPosts;
  const pages = result.results;
  const total = result.total;
  React.useEffect((function () {
    Curry._1(dispatchLoadingBar, /* Start */ 0);
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.blogTags(language),
      tl: {
        hd: Buhta_landing__Api.blogFavorites(language),
        tl: {
          hd: Buhta_landing__Api.blogPosts(pageNum, currentTag.tag, language),
          tl: /* [] */ 0
        }
      }
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
      Curry._1(dispatchLoadingBar, /* Complete */ 1);
    }));
  }), [
    pageNum,
    slug,
    language
  ]);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_landing__BlogHero.make, {
        tags: tags,
        currentTag: currentTag,
        onSearch: (function (value) {
          Curry._1(setQuery, (function (param) {
            return value;
          }));
        }),
        searchField: match$1[0],
        onChangeSearchField: (function (value) {
          Curry._1(setSearchField, (function (param) {
            return value;
          }));
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: query.length !== 0 ? JsxRuntime.jsx(Buhta_landing__BlogSearch.make, {
                query: query,
                clearQuery: (function (param) {
                  Curry._1(setQuery, (function (param) {
                    return "";
                  }));
                  Curry._1(setSearchField, (function (param) {
                    return "";
                  }));
                }),
                language: Buhta_models__Locale.fromString(language)
              }) : JsxRuntime.jsxs(React.Fragment, {
                children: [
                  JsxRuntime.jsx(Buhta_landing__BlogPosts.make, {
                    pages: pages
                  }),
                  total < 8 ? null : JsxRuntime.jsx(Buhta_landing__BlogPagination.make, {
                      pageNum: pageNum,
                      slug: slug,
                      total: total
                    })
                ]
              }),
            className: "lg:w-200"
          }),
          JsxRuntime.jsx(Buhta_landing__BlogSidebar.make, {})
        ],
        className: "px-6 sm:px-48 lg:px-0 lg:w-304 lg:flex lg:mx-auto lg:justify-between mt-6 lg:mt-10 mb-10 lg:mb-20"
      })
    ]
  });
}

const make = BlogHomePage;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
